<template lang="pug">

  .payment-form-container
    form(@submit.prevent='submit', @keydown='form.onKeydown($event)', novalidate='', :class="{ 'has-errors': form.errors.any() }")
      .alert.alert-danger(v-if='error') {{ error }}

      div(v-show="stage == 'products_and_payment'")
        product-payment-form(:form="form", ref="productPaymentForm")

      .new-contact(v-show="stage == 'new_contact'")
        h3.section-title Complete the form below to create an account
          i 3
        .form-group.no-check
          .form-check
            input#sameAsBillingCheckbox(v-model="sameAsBilling", type="checkbox")
            label(for="sameAsBillingCheckbox") Same details as billing
          register(:form="form", ref="registrationForm", :same-as-billing="sameAsBilling")
        .buttons.text-center
          button.btn.btn-primary(type="button", @click='goToPreviousStage') {{ $t('buy_cards.back') }}
          v-button.btn-primary(:loading="form.busy") {{ $t('buy_cards.submit') }}

    modal.buy-curds-success-modal(v-if="stage == 'success'", @close="closeSuccessModal")
      .v-modal-title Success!
      .v-modal-message
        | Your order has been received.<br/>
        | A purchase confirmation has been sent to {{ voucher.user.email }}.<br/>
        | Print it below, or redeem directly from your mobile device.
        invoice-print(:invoice="invoice")
      .v-modal-buttons
        .print-button
          a.btn.btn-primary(:href='pdf', target='_blank') Print Order Confirmation »
        a.resend-link.link(href="#", @click.prevent="resend()") Resend email »
        router-link.register-link.link(v-if="showRegisterLink", :to="{ name: 'register-shadow' }") Register »

    form-success-modal(:form="resendForm" @close="closeResendModal")
      template(slot="title") Success!
      template(slot="message" v-if="voucher") A purchase confirmation has been sent to {{ voucher.user.email }}.
      template(slot="buttons")
        button.btn.btn-primary(@click="closeResendModal") OK

</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex'
import moment from 'moment';

export default {
  name: 'buy-cards',

  props: {
    afterPurchaseRoute: {
      type: String,
      default: 'user.profile'
    }
  },

  created() {
    this.stages = ['products_and_payment', 'success']

    if (this.authenticated) {
      this.form.location_id = this.user.preferred_location_id;
    } else {
      if (window.addiesaas.config.registerWithPurchase) {
        this.registerWithPurchase = true;
        this.stages.splice(1, 0, 'new_contact');
      }
    }

    this.setStage(0)
  },

  data: () => ({
    registerWithPurchase: false,
    stage: null,
    error: null,
    form: new Form({
      first_name: '',
      last_name: '',
      email: '',
      email_confirmation: '',
      password: '',
      password_confirmation: '',
      address: '',
      city: '',
      state: '',
      postcode: '',
      phone: '',
      birthdate: '',
      product: {},
      cc_number: '',
      cc_expiration_year: null,
      cc_expiration_month: null,
      cc_code: '',
      cc_first_name: '',
      cc_last_name: '',
      billing_address: '',
      billing_city: '',
      billing_state: '',
      billing_zip: '',
      billing_country: null,
      location_id: null
    }),
    resendForm: new Form({
      number: '',
      code: ''
    }),
    code: null,
    voucher: null,
    pdf: null,
    invoice: null,
    sameAsBilling: false,
    showRegisterLink: false
  }),

  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    })
  },

  methods: {
    goToPreviousStage() {
      const currentStageIndex = this.stages.indexOf(this.stage)
      this.setStage(currentStageIndex - 1)
    },

    goToNextStage() {
      const currentStageIndex = this.stages.indexOf(this.stage)
      this.setStage(currentStageIndex + 1)
    },

    setStage(index) {
      this.stage = this.stages[index];
      if (this.stage == 'new_contact' && this.sameAsBilling) {
        this.$refs.registrationForm.copyBilling();
      }
    },

    prepareSubmit() {
      Object.assign(this.form.product, this.$store.state['pay/invoices'].products);

      this.form.cc_expiration_month = this.form._cc_expiration_month ? this.form._cc_expiration_month.value : null;
      this.form.cc_expiration_year = this.form._cc_expiration_year ? this.form._cc_expiration_year.value : null;

      this.form.preferred_location_id = this.form._preferred_location_id ? this.form._preferred_location_id.id : null;

      this.form.birthdate = moment(this.form.birthdate).format('YYYY-MM-DD');
    },

    async prevalidate() {
      this.prepareSubmit();
      await this.form.post(`${window.addiesaas.url}/api/playcards/voucher/buy/prevalidate`);
      this.goToNextStage();
    },

    async submit() {
      // try {
        this.error = null;

        this.prepareSubmit();

        const {data} = await this.form.post(`${window.addiesaas.url}/api/playcards/voucher/buy`);

        this.error = data.error;

        if ('voucher' in data) {
          this.$store.dispatch('clearProducts');

          this.code = data.code;
          this.voucher = data.voucher;
          this.pdf = data.pdf;
          this.invoice = data.invoice;

          if (data.shadow_token) {
            this.$store.dispatch('saveShadowToken', { shadow_token: data.shadow_token });
            this.showRegisterLink = true;
          } else {
            this.showRegisterLink = false;
          }

          this.goToNextStage();
        }
      // } catch (e) {
        // const paymentFormFields = ['cc_number', 'cc_expiration_year', 'cc_expiration_month', 'cc_code',
        //   'cc_first_name', 'cc_last_name', 'billing_address', 'billing_city', 'billing_zip', 'billing_country'];
        
        // Object.keys(this.form.errors.all()).forEach(x => {
        //   if (paymentFormFields.includes(x) || x.startsWith('product')) {
        //     this.setStage(0);
        //   }
        // });
      // }
    },

    closeSuccessModal() {
      this.clearForm();
      this.redirectAfterClose();
    },

    closeResendModal() {
      this.resendForm.successful = false;
      this.redirectAfterClose();
    },

    clearForm() {
      this.setStage(0);
      this.form.reset();
      this.$refs.productPaymentForm.updateTotal();
      this.error = this.code = this.voucher = this.pdf = null;
    },

    async resend () {
      this.resendForm.number = this.voucher.number;
      this.resendForm.code = this.code;
      await this.resendForm.post(`${window.addiesaas.url}/api/playcards/voucher/resend`);
      this.clearForm();
    },

    redirectAfterClose() {
      if (this.authenticated) {
        this.$router.push({ name: this.afterPurchaseRoute })
      } else {
        this.$router.push({ name: 'sign-in' })
      }
    },
  }
}
</script>
